<template lang="pug" src="./active-delivery-order.pug"></template>
<style lang="scss" src="../active-order/active-order.scss" scoped></style>

<script>
import {mapGetters, mapState} from 'vuex';
import copyToClipboard from '@/utils/copy';
import config from '../../../../../config.json';
import helpers from '@/utils/helpers';
import orderAddress from '@/views/pages/ReceiveOrders/order-address';
import infoOrder from '@/views/pages/ReceiveOrders/info-order';
import orderHistory from '@/views/pages/ReceiveOrders/order-history';
import request from "@/utils/request";
import {cnb} from 'cnbuilder';
import {VTextarea} from "vuetify/lib/components";
import {declination} from "@/utils/translation";
import {DateTime} from "luxon";
import Vue from "vue";
import {localizeField} from "@/helpers/locales";

export default {
    components: {
        'v-order-address': orderAddress,
        'v-info-order': infoOrder,
        'v-order-history': orderHistory,
        'v-textarea': VTextarea
    },
    props: {
        activeOrderId: {
            type: Number,
            required: true
        },
        showOrderHistory: {
            type: Boolean
        }
    },
    data: () => ({
        isSearchAuto: false,
        assignDriverModal: false,
        assignCallsign: '',
        pooling: null,
        poolingLateTime: null,
        orderHistoryPolling: null,
        freshDataPolling: null,
        timer: '00:00',
        isShowCancelReasons: false,
        isShowOrderCancelDetails: false,
        cancelOrderDetails: {
            questionType: null,
            explanation: null,
            isResolved: false
        },
        isUpdatedPhoneNumber: false,
        lateTime: '00:00',
        orderData: {
            brand: null,
            customerPhone: '',
            tariff: null,
            comment: '',
            tips: '',
            reducedTariff: false,
            deliveryCookTime: null
        },
        selectedDate: {
            value: 'now'
        },
        callSign: '',
        validDate: '',
        minutesToCookOrder: null,
        isCustomerPhoneDisabled: true,
        statusesFullDisabled: ['accepted', 'arrived', 'landed', 'completed', 'cancelled'],
        activeOrder: {
            status: 'new'
        },
        notLoadData: true,
        saveData: false,
        requestProcessing: false,
        canFocusHouse: true,
        tariffSearch: '',
        deliveryStatus: 'new',
        deliveryCancelReason: null,
        notAcceptedDialog: false,
        acceptedDialog: false,

        poolingDeliveryTime: null,
        cookTimer: '00:00',

        cookingDeadlineTimer: '00:00:00',
        cookingDeadlineTimerId: null,

        minCookTime: null,
        maxCookTime: null,

        isCookingLate: false
    }),
    setup() {
        return {
            localizeField
        };
    },
    computed: {
        ...mapGetters(['user', 'roleName']),
        ...mapState({
            brands: (state) => state.data.brands,
            tariffs(state) {
                if (!this.orderData.brand) return [];

                return state.data.brandOptions
                    && state.data.brandOptions[this.orderData.brand.id]
                    && state.data.brandOptions[this.orderData.brand.id].tariffs
                        .map(it => this.optionHandler(it));
            },
            orderHistories: (state) => state.orders.orderHistories,
            clientStatusesHistory: (state) => state.orders.clientStatusesHistory,
            orderDrivers: (state) => state.orders.orderDrivers,
            filteredOrderDrivers: (state) => state.orders.filteredOrderDrivers,
            brandDetails(state) {
                return state.orders.brandDetails
                    && state.orders.brandDetails[
                    this.orderData.brand && this.orderData.brand.id
                        ];
            },
            allOrders: (state) => state.orders.allOrders,
            coordinates: (state) => state.orders.coordinates,
            isShowHistory: (state) => state.orders.isShowHistory,
            addresses: (state) => state.orders.activeOrderAddresses
        }),
        showUserInfo() {
            return !['admin-delivery', 'manager-establishment', 'manager-establishment-ext', 'admin-establishment'].includes(this.roleName);
        },
        cancelReasons() {
            if (this.activeOrder.isSos) {
                return [config.deliveryReasons.find(it => it.value === 'notSos')];
            } else {
                return config.deliveryReasons.filter({use: true});
            }
        },
        questionsTypes() {
            const types = config.orderCancelDetails.questionsTypes;
            const translationPath = '$vuetify.pages.ReceiveOrders.cancelOrderDetails.questionsList';

            return types.map(key => ({
                key,
                value: this.$vuetify.lang.t(`${translationPath}.${key}`)
            }));
        },
        explanationTypes() {
            const {isResolved, questionType} = this.cancelOrderDetails;
            const translationPath = '$vuetify.pages.ReceiveOrders.cancelOrderDetails.explanationsList';

            const resolveText = isResolved ? 'resolved' : 'unresolved';
            const types = config.orderCancelDetails.explanation[resolveText];

            return types && types[questionType] && types[questionType].map(key => ({
                key,
                value: this.$vuetify.lang.t(`${translationPath}.${key}`)
            }));
        },
        time: function () {
            if (!this.selectedDate.value) return null;
            return Date.create(new Date()).addMinutes(config.minPreOrderTime + 1);
        },
        isSearching: function () {
            return this.activeOrder.status === 'searching';
        },
        isPreAssign: function () {
            return this.activeOrder.status === 'searching' && this.activeOrder.isPreAssign;
        },
        price: function () {
            return this.orderData.price;
        },
        iShowPrice: function () {
            return this.orderData.price && this.addresses.length > 1;
        },
        canStartSearch: function () {
            // const isFilled = this.addresses.every(it => it.street || it.osmId);
            // return !this.canCalculateRoute && isFilled && this.activeOrder.status !== 'arrived';
            return (['cooking', 'readyForDelivery'].includes(this.activeOrder.deliveryStatus) && ['new'].includes(this.activeOrder.status)) || (['cancelled'].includes(this.activeOrder.status) && this.showUserInfo);
        },
        canUpdateStatus() {
            return /*['admin-delivery', 'manager-establishment'].includes(this.roleName) && */['new', 'cooking', 'paid'].includes(this.activeOrder.deliveryStatus);
        },
        // canStartWait: function () {
        //   const notAllowedStatuses = ['accepted', 'waiting', 'arrived'];
        //   return !this.isPreAssign && !notAllowedStatuses.includes(this.activeOrder.status);
        // },
        kitchenStatuses() {
            return config.delivery.kitchenResponsibility.filter(Boolean).map(status => ({
                label: this.$vuetify.lang.t(`$vuetify.statuses.delivery.${status}`),
                color: 'green',
                value: status
            }));
        },
        nextStatus() {
            return this.kitchenStatuses[Math.max(this.kitchenStatuses.findIndex(item => item.value === this.activeOrder.deliveryStatus) + 1, -2)];
        },
        isDisableField: function () {
            return this.isSearching && this.isPreAssign || this.activeOrder.status === 'arrived';
        },
        isDeliveryTime() {
            return !this.activeOrder.isLate && this.activeOrder.deliveryTime && this.activeOrder.status === 'accepted';
        },
        isLateTime() {
            return this.activeOrder.isLate && this.activeOrder.status === 'accepted';
        },
        // isSearch() {
        //   return this.canStartSearch && !this.isPreAssign
        //       && this.activeOrder.status != 'accepted';
        // },
        isEdit() {
            return this.isSearching && this.isPreAssign && !this.activeOrder.isSos;
        },
        canceledDelivery() {
            return ['notAccepted', 'canceledKitchen', 'canceledClient', 'canceledClientPayment'].includes(this.activeOrder.deliveryStatus);
        },
        isShowForced() {
            return config.forcedAppointment && this.isSearching && this.isPreAssign;
        },
        disabledSetUnactive() {
            // return !this.activeOrder.isSos && this.activeOrder.status === 'searching' && !this.canStartSearch; //TODO find out what this is
            return false;
        },
        deliveryOrderDetails() {
            const {deliveryOrderDetails} = this.activeOrder;
            return (deliveryOrderDetails || []).map((item) => ({
                productName: item.product[this.localizeField('name', this.$vuetify.lang.current)],
                price: +item.price,
                quantityType: item.product.quantityType,
                weight: item.product.weight,
                quantity: +item.quantity
            }));
        },
        // canShowFullPaymentInfo() {
        //   return ['admin', 'admin-delivery', 'operator'].includes(this.roleName);
        // },
        isLate() {
            return this.cookingDeadlineTimerId && DateTime.fromISO(this.activeOrder.deliveryCookTime).toMillis() < DateTime.now().toMillis();
        },
    },
    watch: {
        'activeOrder.deliveryStatus'() {
            if (['accepted', 'cooking', 'paid'].includes(this.activeOrder.deliveryStatus)) {
                this.initDeadlineTimer();
            } else if (this.cookingDeadlineTimerId) {
                clearInterval(this.cookingDeadlineTimerId);
                this.cookingDeadlineTimerId = null;
            }
        }
    },
    created: async function () {
        await this.$store.dispatch('data/getOptions');
        this.$store.dispatch('orders/getOrderData', this.activeOrderId).then(data => {
            if (data) {
                this.activeOrder = Object.assign({}, data, {
                    orderOptions: data.orderOptions.map(it => this.optionHandler(it)),
                });
                this.notLoadData = false;
                this.freshDataPolling = setInterval(this.checkFreshData, 3000);

                if (['accepted', 'cooking', 'paid'].includes(this.activeOrder.deliveryStatus)) {
                    this.initDeadlineTimer();
                }

                this.initOrderWindow();
            }
        });
    },
    beforeDestroy: function () {
        window.removeEventListener('keydown', this.keydownHandler);

        this.$store.commit('data/CLEAR_BRAND_OPTIONS');
        this.$store.commit('orders/SET_ACTIVE_ORDER_ADDRESSES', [{}]);
        this.resetMarkers();

        clearInterval(this.pooling);
        clearInterval(this.orderHistoryPolling);
        clearInterval(this.freshDataPolling);
        clearInterval(this.cookingDeadlineTimerId);
        clearInterval(this.poolingLateTime);
    },
    mounted() {
        window.addEventListener('keydown', this.keydownHandler);
    },
    methods: {
        keydownHandler(event) {
            if (event.repeat || event.defaultPrevented) {
                return;
            }

            // if ((this.notAcceptedDialog || this.acceptedDialog) && event.keyCode === 27) {
            //   this.notAcceptedDialog = false;
            //   this.acceptedDialog = false;
            //
            //   return;
            // }

            if (this.canStartSearch) {
                if (event.ctrlKey && event.keyCode === 13) {
                    this.searchOrder();
                    return;
                }
            }
            if (event.keyCode === 27) {
                this.setOrderToWait();
                return;
            }
        },
        assignDriver() {
            if (this.assignCallsign) {
                this.requestProcessing = true;
                this.$store.dispatch('orders/assignDriver', {
                    orderId: this.activeOrder.id,
                    callSign: this.assignCallsign
                }).then((success) => {
                  this.requestProcessing = false;
                  this.assignDriverModal = false;

                  if (success) {
                    this.$store.dispatch('alert/addMessage', {
                      type: 'success',
                      message: this.$vuetify.lang.t(`$vuetify.pages.ReceiveOrders.assignedSuccessfully`, [this.assignCallsign]),
                      locale: false
                    });

                    this.setOrderToWait();
                  } else {
                    this.$store.dispatch('alert/addMessage', {
                      type: 'error',
                      message: this.$vuetify.lang.t(`$vuetify.pages.ReceiveOrders.assignError`),
                      locale: false
                    });
                  }

                    this.assignCallsign = '';
                });
            }
        },
        initDeadlineTimer() {
            this.cookingDeadlineTimerId = setInterval(() => {
                this.cookingDeadlineTimer = Object.values(DateTime.fromISO(this.activeOrder.deliveryCookTime).diff(DateTime.now(), ['hours', 'minutes', 'seconds']).toObject()).map(i => String(Math.abs(Math.floor(i))).padStart(2, '0')).join(':');
            }, 1000);
        },
        getDeliveryStatusHandler(statusKey) {
            const statusesActionsMapping = {
                accepted: this.openAcceptedDialog,
                notAccepted: this.openNotAcceptedDialog,
                canceledKitchen: this.openNotAcceptedDialog,
                cooking: () => {
                    this.changeDeliveryOrderStatus({
                        deliveryStatus: 'cooking'
                    }, Function.prototype);
                },
                readyForDelivery: () => {
                    this.changeDeliveryOrderStatus({
                        deliveryStatus: 'readyForDelivery'
                    }, Function.prototype);
                }
            };
            return statusesActionsMapping[statusKey] || null;
        },
        isValidAddress(index) {
            return this.coordinates.length && !this.coordinates[index];
        },
        changeAddress() {
            this.resetMarkers();
        },
        isDeliveryStatusDisabled(statusKey) {
            const disabledStatuses = [
                'paymentWait',
                'canceledClient',
                'canceledClientPayment',
                'readyForDelivery',
                'handedToCourier',
                'delivered'
            ];

            if (disabledStatuses.includes(statusKey)) {
                return true;
            }

            if (statusKey === this.activeOrder.deliveryStatus) {
                return false;
            }

            return this.activeOrder.deliveryStatus !== 'new';
        },
        openAcceptedDialog() {
            const date = new Date();
            const hours = date.getHours();
            const minutes = date.getMinutes();
            this.minCookTime = `${hours}:${minutes}`;
            this.maxCookTime = `${hours + 3}:59`;
            this.acceptedDialog = true;
        },
        onAcceptedDialogConfirm() {
            if (this.orderData.deliveryCookTime < 1) {
                return;
            }

            const deliveryCookTime = DateTime.now().plus({minutes: parseInt(this.orderData.deliveryCookTime)}).toISO();

            const payload = {
                deliveryStatus: 'accepted',
                deliveryCookTime,
            };

            this.orderData.deliveryCookTime = deliveryCookTime;

            this.changeDeliveryOrderStatus(payload, () => this.closeAcceptedDialog());
        },
        closeAcceptedDialog() {
            this.deliveryCookTime = null;
            this.acceptedDialog = false;
        },
        openNotAcceptedDialog() {
            this.notAcceptedDialog = true;
        },
        onNotAcceptedDialogConfirm() {
            if (this.deliveryCancelReason.length === 0) {
                return;
            }

            const callbackAction = () => this.closeNotAcceptedDialog();
            const payload = {
                deliveryStatus: this.activeOrder.deliveryStatus === 'new' ? 'notAccepted' : 'canceledKitchen',
                deliveryCancelReason: this.deliveryCancelReason,
            };
            this.changeDeliveryOrderStatus(payload, callbackAction);
        },
        closeNotAcceptedDialog() {
            this.notAcceptedDialog = false;
        },
        changeDeliveryOrderStatus(data, closeDialogFn) {
            return request({
                method: 'POST',
                url: `/orders-delivery/${this.activeOrder.id}/changeStatus`,
                data,
            }).then((res) => {
                if (res.status === 200) {
                    if (data.deliveryStatus !== 'accepted') {
                        this.$set(this.activeOrder, 'deliveryStatus', data.deliveryStatus);
                    }

                    closeDialogFn();
                }
            }).catch((err) => {
                // eslint-disable-next-line no-console
                console.error('Error: ', err);
                this.acceptedDialog = false;
            });
        },
        updateOrderHistory: function () {
            if (this.orderHistoryPolling) {
                clearInterval(this.orderHistoryPolling);
            }

            this.orderHistoryPolling = setInterval(() => {
                this.$store.dispatch('orders/getAllOrders', this.activeOrder.id);
            }, config.orderHistoryInterval);
        },

        optionHandler: function (data) {
            if (data.levels && data.levels[0]) {
                return Object.assign(data, {optionName: data.levels[0].optionName});
            }

            return data;
        },
        initOrderWindow: function () {
            const secondTick = 1000;
            this.$store.dispatch('orders/getAllOrders', this.activeOrder.id);
            this.setActiveOptions();
            if (this.isSearching) {
                this.$store.dispatch('orders/getOrderDrivers', this.activeOrder.id);
            }

            if (this.pooling) {
                clearInterval(this.pooling);
            }

            this.pooling = setInterval(() => {
                this.timer = helpers.initControllTimer(this.activeOrder.createdAt);
            }, secondTick);

            if (this.pollingLateTime) {
                clearInterval(this.pollingLateTime);
            }

            this.pollingLateTime = setInterval(() => {
                this.lateTime = helpers.initControllTimer(this.activeOrder.arrivalTime);
            }, secondTick);

            if (this.activeOrder.deliveryCookTime) {
                if (this.poolingDeliveryTime) {
                    clearInterval(this.poolingDeliveryTime);
                }

                this.poolingDeliveryTime = setInterval(() => {
                    const nowMs = new Date().getTime();
                    const targetDateMs = new Date(this.activeOrder.deliveryCookTime).getTime();
                    if (nowMs >= targetDateMs) {
                        this.isCookingLate = true;
                    }
                    this.cookTimer = helpers.initControllTimer(this.activeOrder.deliveryCookTime);
                }, secondTick);
            }

            this.updateOrderHistory();
        },

        addressesArr: function () {
            const addresses = this.activeOrder.addresses;

            return (addresses && addresses.length) ? addresses : [{}];
        },

        editCustomerPhone: function () {
            this.isCustomerPhoneDisabled = false;
            this.canFocusHouse = false;
            this.$nextTick(() => {
                this.$refs.customerPhone.focus();
            });
        },

        onCustomerPhoneChange() {
            this.updateOrders().then(data => {
                if (data && data.client && data.clientId != this.activeOrder.clientId) {
                    this.activeOrder.client = Object.assign({}, data.client);
                    this.activeOrder.clientId = data.clientId;
                    this.activeOrder.previousTariff = data.previousTariff;
                }
            });

            this.isUpdatedPhoneNumber = true;
        },

        isToday(date) {
            return date ? new Date().getDate() == new Date(date).getDate() : null;
        },

        getOrderData() {
            return {
                id: this.activeOrder.id,
                brandId: this.orderData.brand.id,
                chosenOption: this.activeOrder.orderOptions[0] && this.activeOrder.orderOptions[0].id,
                options: this.activeOrder.orderOptions,
                comment: this.orderData.comment,
                tips: this.orderData.tips,
                preOrderTime: this.orderData.preOrderTime,
                addresses: this.addresses,
                phoneNumber: this.orderData.customerPhone,
                reducedTariff: this.orderData.reducedTariff
            };
        },

        setActiveOptions() {
            this.$store.commit('orders/SET_ACTIVE_ORDER_ADDRESSES', this.addressesArr());
            this.orderData.tips = this.activeOrder.tips;
            this.orderData.customerPhone = (this.activeOrder.client && this.activeOrder.client.user) ? this.activeOrder.client.user.phoneNumber : '';
            this.orderData.brand = this.activeOrder.brand;
            this.orderData.comment = this.activeOrder.comment;
            this.orderData.establishment = this.activeOrder.establishment;
            // this.orderData.establishment = {"id":22,"name":"Gagarin Burgers","imgUrl":"https://sprut-delivery-images.s3.eu-north-1.amazonaws.com/establishment%D1%82%D0%B5%D1%81%D1%82%20%D1%82%D0%B5%D1%81%D1%82%20%D1%82%D0%B5%D1%81%D1%82%20%D1%82%D0%B5%D1%81%D1%82%20%D1%82%D0%B5%D1%81%D1%82%20%D1%82%D0%B5%D1%81%D1%82%201651848327622","enabled":true,"description":"единственная бургерная сейчас","minimalPrice":"123123","cookTime":"123","removed":false,"managerPhoneNumber":"387732274962","createdAt":"2022-05-06T14:45:27.871Z","updatedAt":"2022-06-30T10:15:02.129Z","brandId":93,"categoryId":6,"addresses":[{"id":49,"establishmentId":22,"placeId":621950,"createdAt":"2022-06-30T10:15:02.182Z","updatedAt":"2022-06-30T10:15:02.182Z","place":{"coords":{"latitude":"49.23317737116509","longitude":"28.472540430737862"},"id":621950,"street":"Soborna Street","houseNumber":"22","name":"Цитрус","city":"Vinnytsia","osmId":"1","district":"","latitude":"49.23317737116509","longitude":"28.472540430737862","createdAt":"2021-09-24T10:58:37.183Z","updatedAt":"2021-09-24T10:58:37.183Z"}}]}
            if (this.orderData.establishment) {
                this.orderData.establishment.addresses[0].place.description = [this.orderData.establishment.addresses[0].place.street, this.orderData.establishment.addresses[0].place.houseNumber, this.orderData.establishment.addresses[0].place.name, this.orderData.establishment.addresses[0].place.city].filter(Boolean).join(', ');
            }
        },

        disableCustomerPhone() {
            this.canFocusHouse = true;
            this.isCustomerPhoneDisabled = true;
        },

        async setOrderToWait() {
            if (this.activeOrder.status === 'searching') {
                this.searchOrder();
            } else {
                await this.$store.dispatch('orders/setOrderToWait', this.activeOrder.id)
                    .then(this.onDisactiveOrder);
            }
        },

        onTipsChange(tips) {
            this.orderData.tips = tips || null;
        },

        isValidDate(d) {
            return d instanceof Date && !isNaN(d);
        },

        // async waitOrder() {
        //   if (this.requestProcessing) return;
        //
        //   this.requestProcessing = true;
        //
        //   await this.updateOrder().then(() => {
        //     return this.$store.dispatch('orders/waitOrder', this.activeOrder.id);
        //   }).then(this.onDisactiveOrder).finally(() => {
        //     this.$nextTick(() => {
        //       this.requestProcessing = false;
        //     });
        //   });
        // },

        toggleIsShowCancelReasons() {
            this.isShowCancelReasons = !this.isShowCancelReasons;
        },

        onQuestionTypeChange(questionType) {
            this.cancelOrderDetails.explanation = null;
            this.cancelOrderDetails.questionType = questionType;
        },

        onResolvedChange(isResolved) {
            this.cancelOrderDetails.explanation = null;
            this.cancelOrderDetails.isResolved = !!isResolved;
        },

        closeOrderCancelDetails() {
            this.isShowOrderCancelDetails = false;

            this.cancelOrderDetails = {
                questionType: null,
                explanation: null,
                isResolved: false
            };
        },

        onCancelReasonClick(reason) {
            if (reason == 'not-order') {
                this.isShowCancelReasons = false;
                this.isShowOrderCancelDetails = true;
                return;
            }

            this.cancelOrder(reason);
        },

        onCallSignChange(callSign) {
            this.$store.commit('orders/SET_FILTERED_ORDER_DRIVERS', this.orderDrivers.filter(it => it.callSign.match(callSign)));
        },

        async updateOrders(props) {
            const reloadBonuses = props && props.reloadBonuses;
            const data = Object.assign({}, this.getOrderData(), {reloadBonuses});

            return await this.$store.dispatch('orders/updateOrder', data);
        },

        async updateOrder() {
            return await this.$store.dispatch('orders/updateOrder', this.getOrderData());
        },

        onDisactiveOrder(res) {
            if (res) {
                this.$emit('onDisactiveOrder', this.activeOrderId);
            }
        },

        onActiveOrder(res) {
            if (res) {
                this.$emit('onActiveOrder', this.activeOrderId);
            }
        },

        searchOrder() {
            if (this.requestProcessing) return;

            this.requestProcessing = true;

            this.$store.dispatch('orders/searchOrder', this.getOrderData())
                .then(this.onDisactiveOrder)
                .finally(() => {
                    this.$nextTick(() => {
                        this.requestProcessing = false;
                    });
                });
        },

        returnToSearch() {
            if (this.requestProcessing) return;

            if (!this.addresses[0] || !this.addresses[0].latitude) return;

            this.requestProcessing = true;

            this.$store.dispatch('orders/searchOrder', this.getOrderData())
                .then(this.onDisactiveOrder)
                .finally(() => {
                    this.$nextTick(() => {
                        this.requestProcessing = false;
                    });
                });
        },

        checkFreshData() {
            request({
                method: 'get',
                url: `/orders/${this.activeOrderId}/data`,
                params: {updatedAt: this.activeOrder.updatedAt}
            }).then(res => {
                if (res.status === 200) {
                    const data = res.data;
                    const addresses = res.data.unorderedAddresses
                        .sortBy('sortOrder')
                        .map('place')
                        .map(it => Vue.filter('extendAddress')(it));

                    const preparedData = {addresses};
                    const establishment = res.data.establishment;
                    if (establishment && establishment.place) {
                        preparedData.establishment = {
                            ...establishment, place: Vue.filter('extendAddress')(establishment.place)
                        };
                    }

                    this.activeOrder = Object.assign({}, Object.reject(data, ['unorderedAddresses']), preparedData, {
                        orderOptions: res.data.orderOptions.map(it => this.optionHandler(it)),
                    });

                    this.initOrderWindow();
                } else {
                    return null;
                }
            }).catch(() => null);
        },

        saveOrderData() {
            if (this.saveData) {
                return;
            }

            this.saveData = true;

            this.updateOrder().then(data => {
                if (data) {
                    this.$store.dispatch('alert/addMessage', {
                        type: 'success',
                        message: 'success'
                    }, {root: true});
                }

                setTimeout(() => {
                    this.saveData = false;
                }, 2000);
            });
        },

        async cancelOrder(cancelReason, id = this.activeOrder.id) {
            if (this.requestProcessing) return;
            this.requestProcessing = true;

            const requestPayload = {id, cancelReason};
            if (cancelReason === 'not-order') {
                Object.assign(requestPayload, {
                    ...this.cancelOrderDetails
                });
            }

            await this.$store.dispatch('orders/cancelOrder', requestPayload)
                .then(this.onDisactiveOrder)
                .finally(() => this.$nextTick(() => {
                    this.requestProcessing = false;
                }));
        },

        editOrder() {
            if (this.requestProcessing) return;

            this.requestProcessing = true;

            this.$store.dispatch('orders/editOrder', this.activeOrder.id).then(res => {
                if (res && this.activeOrder.status === 'searching') {
                    this.activeOrder.isPreAssign = false;
                }
            }).then(() => {
                this.$nextTick(() => {
                    this.requestProcessing = false;
                });
            });
        },

        async saveOrder() {
            if (this.requestProcessing) return;

            this.requestProcessing = true;

            await this.$store.dispatch('orders/saveOrder', this.getOrderData())
                .then(this.onDisactiveOrder)
                .finally(() => {
                    this.$nextTick(() => {
                        this.requestProcessing = false;
                    });
                });
        },

        deleteAddress(event, index) {
            this.$store.commit('orders/REMOVE_ACTIVE_ORDER_ADDRESS', index);

            if (this.addresses.length < 2) {
                this.resetMarkers();
            }

            if (this.orderData.price) {
                this.orderData.price = null;
            }
        },

        closeHistory() {
            if (this.isShowHistory) {
                this.$store.commit('orders/SET_IS_SHOW_HISTORY', false);
            }
        },

        resetMarkers() {
            this.$store.commit('orders/SET_COORDINATES', []);
            this.$store.commit('orders/SET_POLYLINE', []);
            this.$store.commit('orders/CLEAR_ADDRESS_COORDS');
        },

        copyToClipboard,
        cnb,
        declination
    }
};
</script>
